import { Vehicle } from 'types/vehicle';
import { useDispatch, useSelector } from 'react-redux';
import { modalsToggle } from 'actions';
import { ConfirmAcceptBuyerOfferModal } from './acceptBuyerOfferModal';
import { MakeAlternativeOfferModal } from 'pages/Seller/VehicleSales/components/MakeAlternativeOfferModal';
import { ActionRow } from '../ActionRow';
import { formatCurrency } from 'utils';

export const BuyerAlternativeOffer = ({ vehicle }: { vehicle: Vehicle }) => {
  const buyerOffer = vehicle.top_alternative_bid_offer;

  const user = useSelector((state: any) => state.user.user);

  const dispatch = useDispatch();

  const openAcceptModal = () => {
    dispatch(modalsToggle(`accept-alternative-offer-${vehicle.id}`));
  };

  return (
    <>
      <ActionRow
        label={`Buyer Offer: ${buyerOffer ? formatCurrency(buyerOffer.amount) : 'N/A'}`}
        buttonConfig={{
          handleClick: openAcceptModal,
          label: 'Accept Offer',
          disabled: (!buyerOffer || vehicle.in_battle) && user.role !== 'admin'
        }}
      />
      <ConfirmAcceptBuyerOfferModal vehicleId={vehicle.id} offerAmount={buyerOffer?.amount} />
    </>
  );
};

export const SellerAlternativeOffer = ({ vehicle }: { vehicle: Vehicle }) => {
  const alternativeOffer = vehicle.active_alternative_offer;
  const dispatch = useDispatch();
  const user = useSelector((state: any) => state.user.user);

  const counterDisabled = vehicle.in_battle && user.role !== 'admin';

  const openModal = () => {
    if (counterDisabled) {
      return;
    }

    dispatch(modalsToggle(`makeAlternativeOffer-${vehicle.id}`));
  };
  return (
    <>
      <ActionRow
        label={`Seller Offer: ${alternativeOffer ? formatCurrency(alternativeOffer.amount) : 'N/A'}`}
        buttonConfig={{
          handleClick: openModal,
          label: 'Counter',
          disabled: counterDisabled
        }}
      />

      <MakeAlternativeOfferModal currentVehicle={vehicle} />
    </>
  );
};
